<!--
  PlaceIcon.vue
    行先アイコン Component

-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <div>
  <div :class="onlyMobile">
    <v-avatar
      size="8vw"
      :color=currentPresence.icon_color
      class="hm-mp-icon-back"
    >
      <v-icon color="white" size="6vw">{{ currentPresence.icon_name }}</v-icon>
    </v-avatar>
  </div>
  <div :class="onlyMonitor">
    <v-avatar
      size="4vw"
      :color=currentPresence.icon_color
      class="hm-mp-icon-back"
    >
      <v-icon color="white" size="3.25vw">{{ currentPresence.icon_name }}</v-icon>
    </v-avatar>
  </div>
  <div :class="onlyMenuList">
    <v-btn icon>
    <v-avatar
      size="40"
      :color=currentPresence.icon_color
      class="hm-mp-icon-back"
    >
      <v-icon color="white" size="24">{{ currentPresence.icon_name }}</v-icon>
    </v-avatar>
    </v-btn>
  </div>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { isNullorUndefined } from '@/common'

export default {
  name: 'PlaceIcon',
  props: [ 'pStatusId', 'pViewMode' ],
  data: () => ({
    mPresenceDefault: {
      state_id: 0,
      state_name: '-',
      icon_name: 'error',
      icon_color: 'bleck',
    },
  }),
  mounted: function () {
    //this.$log.debug('# PlaceIcon ' + this.pStatusId)
    //this._findPresenceStatus(this.pStatusId)
  },
  destroyed: function () {
    //this.$log.debug('# PlaceIcon ')
  },
  computed: {
    ...mapState({
      mPresenceStatusList: state => state.sPresenceStatusList,
    }),
    currentPresence: function () {
      return this._findPresenceStatus(this.pStatusId)
    },
    onlyMenuList: function () {
      return {'hm-hide': this.pViewMode !== 'menulist'}
    },
    onlyMobile: function () {
      return {'hm-hide': this.pViewMode !== 'mobile'}
    },
    onlyMonitor: function () {
      return {'hm-hide': this.pViewMode !== 'monitor'}
    },
  },
  methods: {
    // -------------------------------------------------------------------------
    _findPresenceStatus: function (statusId) {
      // 本Componentが読み込まれるタイミングによってはnullの場合がある
      // その場合はdefault値を返す
      if (isNullorUndefined(statusId)) {
        return this.mPresenceDefault
      }
      let presenceStatus = this.mPresenceStatusList.find((elm) => {
        return (elm.state_id.toString() === statusId.toString())
      })

      if (isNullorUndefined(presenceStatus)) {
        this.$log.warn('current presence status is null.')
        // 見つからない場合はdefault値を返す
        return this.mPresenceDefault
      }
      return presenceStatus
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
/* @Todo IE11ではセンタリングされない */
/*
.hm-pi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
}
*/
.hm-mp-icon-back {
  /*
  height: 8vw;
  width: 8vw;
  */
  border-radius: 5px;          /* css3 draft */
  -webkit-border-radius: 5px;  /* Safari, Chrome */
  -moz-border-radius: 5px;     /* Firefox */
}
/*
@media screen and (min-width: 601px) {
.hm-mp-icon-back {
  height: 5vw;
  width: 5vw;
}
}
*/

</style>



// WEBPACK FOOTER //
// src/components/parts/PlaceIcon.vue